/*
 *   Copyright (c) 2021 RCUBE PLANET PVT LTD
 *   All rights reserved.
 */
import React, { useContext } from 'react'
import { UncontrolledDropdown, DropdownMenu, DropdownItem, DropdownToggle } from 'reactstrap'
import * as Icon from 'react-feather'
import { history } from '../../../history'
import Avatar from '../../../components/@vuexy/avatar/AvatarComponent'

import { AuthContext } from '../../../auth/Auth'

const UserDropdown = () => {
  let context = useContext(AuthContext)
  return (
    <DropdownMenu right>
      <DropdownItem tag="a" href="#" onClick={() => history.push(`/edit/list?id=${context.user?.id}`)}>
        <Icon.User size={14} className="mr-50" />
        <span className="align-middle">Edit Profile</span>
      </DropdownItem>
      <DropdownItem tag="a" href="#" onClick={() => context.logout()}>
        <Icon.Power size={14} className="mr-50" />
        <span className="align-middle">Log Out</span>
      </DropdownItem>
    </DropdownMenu>
  )
}

const NavbarUser: React.FC = (props: any) => {
  let context = useContext(AuthContext)

  const name = context.user?.name || ''
  const getAvatarContent = () => {
    return (
      name
        ?.split(' ')
        ?.map((a: string) => a.charAt(0))
        ?.join('')
        .toUpperCase() || ''
    )
  }

  return (
    <ul className="nav navbar-nav navbar-nav-user float-right">
      <UncontrolledDropdown tag="li" className="dropdown-user nav-item">
        <DropdownToggle tag="a" className="nav-link dropdown-user-link">
          <div className="user-nav d-sm-flex d-none">
            <span className="user-name text-bold-600">{name}</span>
            <span className="user-status">Available</span>
          </div>
          <span data-tour="user">
            {/* <img src={this.props.userImg} className="round" height="40" width="40" alt="avatar" /> */}
            <Avatar color="success" className="mr-1" content={getAvatarContent()} />
          </span>
        </DropdownToggle>
        <UserDropdown {...props} />
      </UncontrolledDropdown>
    </ul>
  )
}
export default NavbarUser
